var map = {
	"./app.svg": "43bc",
	"./dashboard.svg": "f782",
	"./example.svg": "30c3",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./home.svg": "6bbe",
	"./kaifa.svg": "3cb7",
	"./kchat.svg": "ad3b",
	"./kzmb.svg": "cf65",
	"./liaotian.svg": "66bb",
	"./link.svg": "18f0",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./shezhi.svg": "9aa1",
	"./table.svg": "47f1",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./users.svg": "5055",
	"./wait.svg": "36d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";